import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { API } from "../lib/api";
import { useAuth } from "./AuthContext";

const EMPTY = { items: [], count: 0, subtotal: 0, discount: 0, total: 0, bundle: {} };
const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState(EMPTY);

  const refresh = useCallback(async () => {
    if (!user) { setCart(EMPTY); return; }
    try { const { data } = await API.get("/cart"); setCart(data); } catch { /* noop */ }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return <CartCtx.Provider value={{ cart, setCart, refresh }}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
